$(document).ready(function() {
  $(document).on('change', '#preventive_maintenance_repeating_type, #preventive_maintenance_schedule_versions', function () {
    var f = $("#preventive_maintenance_repeating_type").val()
    var repeats_type = $('#preventive_maintenance_schedule_versions').val()
    if (f == 'week' && repeats_type == "regularly") {
      $('#for_week_view').css('display', 'block')
      $('#for_month_views').css('display', 'none')
    }
    else if (f == 'month' && repeats_type == "regularly") {
      $('#for_week_view').css('display', 'none')
      $('#for_month_views').css('display', 'block')
    }
    else {
      $('#for_week_view').css('display', 'none')
      $('#for_month_views').css('display', 'none')
    }
  })

  $(document).on('change', "#preventive_maintenance_primary_asset_id", function (e)
    {
      console.log("ppppppp1")
      var assetID = $(this).val()
      console.log(assetID)
      $.ajax({
      type: 'GET',
      dataType: 'json',
      url: `/api/v1/checklists`,
      data: { asset_id: assetID },
      success: function(response) {

        console.log("response");
        console.log(response);
        // var checklistIds = response.data.map(item => { return item.id;});
        const checklistIds = response.data.flatMap(item =>
          item.checklist_revisions
            ?.filter(rev => rev.status === 'active')
            .map(rev => rev.id) || []
        );

        console.log(checklistIds)
        $(`#preventive_maintenance_checklist_version_ids`).val(checklistIds).trigger('change');
      },
      error: function(error){console.log(error)}
      });
    })
})